export default __webpack_public_path__ + "static/media/abb-color.2d535fee.svg";